import { GridList } from '@sleepstation/components'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import ResourceCard from '../ResourceCard'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(GridList).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  columns: [1, 2, 3],
  'data-cy': `resource-list`,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ResourcesList = ({ resources }) => (
  <Layout>
    {renderList(
      ({ node }) => (
        <ResourceCard {...node} />
      ),
      resources
    )}
  </Layout>
)

ResourcesList.propTypes = {
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ResourcesList
